import { PlanAnalyticStore } from '../types/store';

let initialState: PlanAnalyticStore = {
  data: null,
  isFetching: false,
  lastUpdate: null
};

export default initialState;
